<template>
    <b-container>
        <b-row class="my-3">
            <b-col class="product-holder">
                <b-img src="https://s3-media0.fl.yelpcdn.com/bphoto/x_4IFS_prz6Bt6klvzqqQg/300s.jpg" 
                    rounded width="300" height="250"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div class="h5 mb-0">
                    <strong>Bake House</strong>
                </div>
                <div>
                    By Katrina E.
                </div>
                <div class="text-muted d-flex flex-row">
                    <div>
                        <b-icon icon="star-fill" style="color: #ffa500;" font-scale="1.25"></b-icon>
                        <b-icon icon="star-fill" style="color: #ffa500;" font-scale="1.25"></b-icon>
                        <b-icon icon="star-fill" style="color: #ffa500;" font-scale="1.25"></b-icon>
                        <b-icon icon="star-fill" style="color: #ffa500;" font-scale="1.25"></b-icon>
                        <b-icon icon="star-fill" style="color: #ffa500;" font-scale="1.25"></b-icon>
                    </div>
                    <div class="mx-2">1</div>
                </div>
                <div class="text-muted">
                    ₱₱₱ Bakeries, Cafes
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<style scoped>

</style>

<script>
export default {
    
}
</script>